import UserEditionForm from './UserEditionForm';

export default UserEditionForm;
